(function () {
  'use strict';

  var imgs = [], idx = 0, currentVariantId = null;

  function buildModal() {
    var existing = document.getElementById('qv-modal');
    if (existing) existing.remove();

    var modal = document.createElement('div');
    modal.id = 'qv-modal';
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    modal.innerHTML = `
      <div id="qv-backdrop"></div>
      <div id="qv-inner">
        <button id="qv-close" aria-label="Close">&#x2715;</button>
        <div id="qv-left">
          <div id="qv-image-track"></div>
          <button id="qv-prev">&#8249;</button>
          <button id="qv-next">&#8250;</button>
          <div id="qv-dots"></div>
        </div>
        <div id="qv-right"></div>
      </div>
    `;
    document.body.appendChild(modal);

    document.getElementById('qv-close').addEventListener('click', closeModal);
    document.getElementById('qv-backdrop').addEventListener('click', closeModal);
    document.getElementById('qv-prev').addEventListener('click', function () { changeImage(-1); });
    document.getElementById('qv-next').addEventListener('click', function () { changeImage(1); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    var track = document.getElementById('qv-image-track');
    var tx = 0;
    track.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) changeImage(diff > 0 ? 1 : -1);
    });
  }

  function changeImage(dir) {
    if (imgs.length <= 1) return;
    idx = (idx + dir + imgs.length) % imgs.length;
    renderImg();
  }

  function renderImg() {
    var t = document.getElementById('qv-image-track');
    if (!t) return;
    t.innerHTML = '';
    var i = document.createElement('img');
    i.src = imgs[idx]; i.alt = '';
    t.appendChild(i);
    document.querySelectorAll('.qv-dot').forEach(function (d, n) {
      d.classList.toggle('qv-dot--active', n === idx);
    });
  }

  function openModal() {
    document.getElementById('qv-modal').classList.add('qv-active');
    document.body.classList.add('qv-overflow-hidden');
  }

  function closeModal() {
    var m = document.getElementById('qv-modal');
    if (m) m.classList.remove('qv-active');
    document.body.classList.remove('qv-overflow-hidden');
  }

  function updateCart() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newBubble = doc.querySelector('.shopify-section');
        var oldBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
      });
  }


  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  function buildRight(p) {
    var right = document.getElementById('qv-right');

    // Variant options
    var optionsHTML = '';
    if (p.variants.length > 1) {
      optionsHTML = '<div id="qv-variants">';
      p.options.forEach(function (optName, optIndex) {
        var values = [];
        p.variants.forEach(function (v) {
          var val = v.options[optIndex];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHTML += '<div class="qv-option-group"><div class="qv-option-label">' + optName + '</div><div class="qv-option-btns">';
        values.forEach(function (val) {
          optionsHTML += '<button class="qv-opt-btn" data-opt-index="' + optIndex + '" data-opt-value="' + val + '">' + val + '</button>';
        });
        optionsHTML += '</div></div>';
      });
      optionsHTML += '</div>';
    }

    // Price
    var price = (p.variants[0].price / 100).toFixed(2);

    right.innerHTML = `
      <h2 id="qv-title">${p.title}</h2>
      <div id="qv-price">$${price}</div>
      ${optionsHTML}
      <div id="qv-qty-row">
        <button id="qv-qty-minus">−</button>
        <input id="qv-qty" type="number" value="1" min="1" max="99" />
        <button id="qv-qty-plus">+</button>
      </div>
      <button id="qv-atc">Add to Cart</button>
      <a id="qv-full-link" href="/products/${p.handle}">View full details</a>
    `;

    // Set first variant
    currentVariantId = p.variants[0].id;

    // Variant selection logic
    var selectedOptions = p.variants[0].options.slice();

    function updateSelectedVariant() {
      var match = p.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selectedOptions[i]; });
      });
      if (match) {
        currentVariantId = match.id;
        var priceEl = document.getElementById('qv-price');
        if (priceEl) priceEl.textContent = '$' + (match.price / 100).toFixed(2);
        if (match.featured_image) {
          var fi = match.featured_image.src.split('?')[0];
          var imgIdx = imgs.indexOf(fi);
          if (imgIdx > -1) { idx = imgIdx; renderImg(); }
        }
      }
    }

    right.querySelectorAll('.qv-opt-btn').forEach(function (btn) {
      if (Number(btn.dataset.optIndex) === 0) {
        // mark first of each group active
        var grp = btn.closest('.qv-option-btns');
        if (!grp.querySelector('.qv-opt-btn--active')) btn.classList.add('qv-opt-btn--active');
      }
      btn.addEventListener('click', function () {
        var optIndex = Number(btn.dataset.optIndex);
        btn.closest('.qv-option-btns').querySelectorAll('.qv-opt-btn').forEach(function (b) { b.classList.remove('qv-opt-btn--active'); });
        btn.classList.add('qv-opt-btn--active');
        selectedOptions[optIndex] = btn.dataset.optValue;
        updateSelectedVariant();
      });
    });

    // Qty
    document.getElementById('qv-qty-minus').addEventListener('click', function () {
      var q = document.getElementById('qv-qty');
      if (parseInt(q.value) > 1) q.value = parseInt(q.value) - 1;
    });
    document.getElementById('qv-qty-plus').addEventListener('click', function () {
      var q = document.getElementById('qv-qty');
      q.value = parseInt(q.value) + 1;
    });

    // Add to cart
    document.getElementById('qv-atc').addEventListener('click', function () {
      var qty = parseInt(document.getElementById('qv-qty').value) || 1;
      var btn = document.getElementById('qv-atc');
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentVariantId, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function () {
          updateCart();
          closeModal();
          setTimeout(openCartDrawer, 300);
        }).catch(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
    });
  }

  function loadProduct(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        imgs = p.images && p.images.length
          ? p.images.map(function (img) { return img.split('?')[0]; })
          : (p.featured_image ? [p.featured_image.split('?')[0]] : []);
        idx = 0;
        renderImg();

        var show = imgs.length > 1;
        document.getElementById('qv-prev').style.display = show ? 'flex' : 'none';
        document.getElementById('qv-next').style.display = show ? 'flex' : 'none';

        var dots = document.getElementById('qv-dots');
        dots.innerHTML = '';
        if (imgs.length > 1) {
          imgs.forEach(function (_, i) {
            var d = document.createElement('span');
            d.className = 'qv-dot' + (i === 0 ? ' qv-dot--active' : '');
            d.addEventListener('click', function () { idx = i; renderImg(); });
            dots.appendChild(d);
          });
        }

        buildRight(p);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-quick-add-btn');
    if (!btn) return;

    var handle = btn.dataset.productHandle;
    if (!handle) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (p.variants.length === 1) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
          }).then(function () {
            updateCart();
            setTimeout(openCartDrawer, 300);
          });
          return;
        }
        buildModal();
        openModal();
        loadProduct(handle);
      });
  }, true);

})();
